
import React from "react";
import { ModuleBase } from '@loanbossinc/component-library';
import styled from "styled-components";
import {
  DefaultModuleHeader
  , MetricSummaryGrid
  , mapMetric
  , DEAL_METRICS
  , HomeWork
} from '@loanbossinc/component-library';

// NOTE: This is a SEVERELY slimmed down version of the property module that is used on the deal page.
//       it was much easier to use parts from it that to make it work. apologies.

const StyledMetricSummaryGrid = styled(MetricSummaryGrid)`
  && {
    position: relative;

    div {
      display: flex;
      flex: 1;
      border-top: none;
      border-bottom: none;
      border-radius: 8px;
    }

    div:first-child {
      border-left: none;
      border-right: none;
    }

    div:last-child {
      border-left: none;
      border-right: none;
    }

    div:not(:first-child):not(:last-child) {
      border-radius: 0;
    }
  }
`;

export class PropertySummary extends React.Component {
  getSummaryMetrics = () => {
    const { property } = this.props;

    // NOTE: Here we are simply creating an object that resembles a deal metric so that the formatter can find the
    //       the proper format for that value without creating new formatters. This should make everything mirror
    //       the deal module set up.

    let metricData;

    if (!property.marketValue && property.appraisedValue > 0) {
      metricData = {
        value: property.appraisedValue,
        id: DEAL_METRICS.APPRAISED_VALUE,
        label: "Appraised Value"
      };
    } else {
      metricData = {
        value: property.marketValue,
        id: DEAL_METRICS.MARKET_VALUE,
        label: "Market Value"
      };
    }

    return [
      {
        title: metricData.label
        , metricValue: mapMetric({ metricId: metricData.id, decimalValue: metricData.value })
        , type: 'CURRENCY'
      }, {
        title: "occupancy"
        , metricValue: property.occupancy / 100
        , type: 'PERCENT_RING'
      }, {
        title: "noi"
        , metricValue: mapMetric({ metricId: DEAL_METRICS.NOI_ACTUAL, decimalValue: property.noiActual })
        , type: 'CURRENCY'
      }
    ];
  };

  getTitleInfo = () => {
    const { property } = this.props;
    if (!property) return { title: null, subTitle: null };

    return {
      title: property.address
      , subTitle: `${property.city || ''}, ${(property.stateRef && property.stateRef.value) || ''} ${property.zip || ''}`
    }
  }

  render() {
    const { property } = this.props;
    if (!property) return null;
    const { title, subTitle } = this.getTitleInfo();

    return (
      <>
        <ModuleBase>
          <DefaultModuleHeader
            headerElement={[<HomeWork />]}
            headerTitle={title}
            subTitle={subTitle}
          />

          <StyledMetricSummaryGrid options={this.getSummaryMetrics()} />
        </ModuleBase>
      </>
    );
  }
}
